/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Tasks_View_KanbanInputs */

const en_my_tasks_view_kanban = /** @type {(inputs: My_Tasks_View_KanbanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kanban view`)
};

const pt_br2_my_tasks_view_kanban = /** @type {(inputs: My_Tasks_View_KanbanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visualização em kanban`)
};

/**
* | output |
* | --- |
* | "Kanban view" |
*
* @param {My_Tasks_View_KanbanInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const my_tasks_view_kanban = /** @type {((inputs?: My_Tasks_View_KanbanInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Tasks_View_KanbanInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_my_tasks_view_kanban(inputs)
	return pt_br2_my_tasks_view_kanban(inputs)
});